export { Thankyou } from './Thankyou';